export default __webpack_public_path__ + "static/media/img_baseBunnyCrochet_rose_p.e6ebf85d.jpg";